<div class="reading-page doc-page">
  <div id="head" class="section-header">
    <h2 class="section-title">{{ title }}</h2>
  </div>
  <app-policy-card [policyBody]="body">
    <!-- Body -->
    <ng-template #body>
      <div class="policy-content">
        <p><strong>This plugin does not collect, store, or process any personal data.</strong></p>

        <p>Codigrate respects your privacy. This plugin operates entirely within your JetBrains IDE and is used solely to
          provide theme-related functionality. No personal information, usage data, or identifiable data is collected,
          stored, or transmitted by the plugin.</p>

        <p>The plugin does not use analytics, tracking technologies, or external services, and it does not share any
          data with third parties.</p>
        <p>If you have any questions about this Privacy Policy or need further information, please contact us at
          <a [href]="'mailto:' + environmentCommon.company.email">{{ environmentCommon.company.email }}</a>.</p>

        <p>Thank you for using our products.</p>

        <p>Kind regards,</p>

        <p><strong>Codigrate Team</strong></p>
      </div>
    </ng-template>
  </app-policy-card>
</div>
